import { SET_TOOLBAR_LIST_CONTAINER_WIDTH } from './types';
import { getListContainerWidth } from '../../client/utils/clientInspectionUtils';

export default function setListContainerWidth() {
  return {
    type: SET_TOOLBAR_LIST_CONTAINER_WIDTH,
    payload: getListContainerWidth(),
  };
}
